import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=6968cbd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6968cbd3"]])

export default __exports__